import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const AboutRBI = () => (
  <>
    <Helmet>
      <title>RBI Regulated NBFC — Compliant & Trusted Lender | Salary Uncle</title>
      <meta name="description" content="Salary Uncle is a fully RBI-registered NBFC adhering to all regulatory norms. Transparent, ethical, and audited lending practices." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/about-us" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to About
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <polyline points="9 12 11 14 15 10"/>
          </svg>
        </div>
        <span className="fd-tag">REGULATORY COMPLIANCE</span>
        <h1>RBI Regulated NBFC</h1>
        <p>Fully compliant with RBI norms — transparent, ethical, and continuously audited lending practices you can trust.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "Valid RBI Certificate", desc: "Salary Uncle operates with a valid Certificate of Registration issued by the Reserve Bank of India." },
            { title: "Fair Practices Code", desc: "We strictly follow the RBI Fair Practices Code — published openly for full transparency." },
            { title: "Transparent Pricing", desc: "All interest rates, processing fees, and charges are disclosed upfront. No hidden charges, ever." },
            { title: "Grievance Redressal", desc: "Formal grievance redressal mechanism aligned with RBI norms — resolution within 7 working days." },
            { title: "Data Protection", desc: "256-bit encryption and RBI-compliant data handling protect every customer's information." },
            { title: "Ethical Recovery", desc: "Recovery practices follow RBI's Code of Conduct — no harassment, only respectful communication." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Our Commitments</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Operate strictly within RBI's regulatory framework for NBFCs." },
              { step: "2", text: "Maintain full transparency in interest rates, fees, and loan terms." },
              { step: "3", text: "Provide clear grievance redressal — escalation to RBI Ombudsman if needed." },
              { step: "4", text: "Ensure customer data is encrypted and never shared without consent." },
              { step: "5", text: "Publish annual compliance reports and Fair Practices Code on our website." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default AboutRBI;
